/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { gql } from '@apollo/client';
export type CmTeasableLayout_CmArticleImpl_Fragment = { __typename?: 'CMArticleImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmAudioImpl_Fragment = { __typename?: 'CMAudioImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmChannelImpl_Fragment = { __typename?: 'CMChannelImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmCollectionImpl_Fragment = { __typename?: 'CMCollectionImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmDownloadImpl_Fragment = { __typename?: 'CMDownloadImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmDynamicListImpl_Fragment = { __typename?: 'CMDynamicListImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmExternalLinkImpl_Fragment = { __typename?: 'CMExternalLinkImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmGalleryImpl_Fragment = { __typename?: 'CMGalleryImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmhtmlImpl_Fragment = { __typename?: 'CMHTMLImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmImageMapImpl_Fragment = { __typename?: 'CMImageMapImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmInteractiveImpl_Fragment = { __typename?: 'CMInteractiveImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmLocTaxonomyImpl_Fragment = { __typename?: 'CMLocTaxonomyImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmMediaImpl_Fragment = { __typename?: 'CMMediaImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmNavigationImpl_Fragment = { __typename?: 'CMNavigationImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmPersonImpl_Fragment = { __typename?: 'CMPersonImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmPictureImpl_Fragment = { __typename?: 'CMPictureImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmPlaceholderImpl_Fragment = { __typename?: 'CMPlaceholderImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmProductImpl_Fragment = { __typename?: 'CMProductImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmQueryListImpl_Fragment = { __typename?: 'CMQueryListImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmSelectionRulesImpl_Fragment = { __typename?: 'CMSelectionRulesImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmSpinnerImpl_Fragment = { __typename?: 'CMSpinnerImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmTaxonomyImpl_Fragment = { __typename?: 'CMTaxonomyImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmTeasableImpl_Fragment = { __typename?: 'CMTeasableImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmTeaserImpl_Fragment = { __typename?: 'CMTeaserImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmVideoImpl_Fragment = { __typename?: 'CMVideoImpl', layoutSettings?: any | null };

export type CmTeasableLayout_CmVisualImpl_Fragment = { __typename?: 'CMVisualImpl', layoutSettings?: any | null };

export type CmTeasableLayout_FormEditorImpl_Fragment = { __typename?: 'FormEditorImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosAmountIncreaseFormImpl_Fragment = { __typename?: 'SOSAmountIncreaseFormImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosAuthorImpl_Fragment = { __typename?: 'SOSAuthorImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosChartImpl_Fragment = { __typename?: 'SOSChartImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosContactImpl_Fragment = { __typename?: 'SOSContactImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosDonationCardImpl_Fragment = { __typename?: 'SOSDonationCardImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosDonationCertificateImpl_Fragment = { __typename?: 'SOSDonationCertificateImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosDonationFormImpl_Fragment = { __typename?: 'SOSDonationFormImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosDonationProductImpl_Fragment = { __typename?: 'SOSDonationProductImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosDonationProgressImpl_Fragment = { __typename?: 'SOSDonationProgressImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosDonationToolImpl_Fragment = { __typename?: 'SOSDonationToolImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosEventImpl_Fragment = { __typename?: 'SOSEventImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosFilterTeaserImpl_Fragment = { __typename?: 'SOSFilterTeaserImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosInternalLinkImpl_Fragment = { __typename?: 'SOSInternalLinkImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosJobTeaserImpl_Fragment = { __typename?: 'SOSJobTeaserImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosLocationImpl_Fragment = { __typename?: 'SOSLocationImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosNewsImpl_Fragment = { __typename?: 'SOSNewsImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosNotificationImpl_Fragment = { __typename?: 'SOSNotificationImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosOfferImpl_Fragment = { __typename?: 'SOSOfferImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosOrderFormImpl_Fragment = { __typename?: 'SOSOrderFormImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosOrganisationImpl_Fragment = { __typename?: 'SOSOrganisationImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosOverlayImpl_Fragment = { __typename?: 'SOSOverlayImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosPressreleaseImpl_Fragment = { __typename?: 'SOSPressreleaseImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosPublicationImpl_Fragment = { __typename?: 'SOSPublicationImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosRedirectPageImpl_Fragment = { __typename?: 'SOSRedirectPageImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosSpecialTopicCategoryImpl_Fragment = { __typename?: 'SOSSpecialTopicCategoryImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosSpecialTopicImpl_Fragment = { __typename?: 'SOSSpecialTopicImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosTeaserImpl_Fragment = { __typename?: 'SOSTeaserImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosTextfragmentImpl_Fragment = { __typename?: 'SOSTextfragmentImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosTooltipImpl_Fragment = { __typename?: 'SOSTooltipImpl', layoutSettings?: any | null };

export type CmTeasableLayout_SosWimmelbildImpl_Fragment = { __typename?: 'SOSWimmelbildImpl', layoutSettings?: any | null };

export type CmTeasableLayout_ViewTypeHeroCollection_Fragment = { __typename?: 'ViewTypeHeroCollection', layoutSettings?: any | null };

export type CmTeasableLayoutFragment = CmTeasableLayout_CmArticleImpl_Fragment | CmTeasableLayout_CmAudioImpl_Fragment | CmTeasableLayout_CmChannelImpl_Fragment | CmTeasableLayout_CmCollectionImpl_Fragment | CmTeasableLayout_CmDownloadImpl_Fragment | CmTeasableLayout_CmDynamicListImpl_Fragment | CmTeasableLayout_CmExternalLinkImpl_Fragment | CmTeasableLayout_CmGalleryImpl_Fragment | CmTeasableLayout_CmhtmlImpl_Fragment | CmTeasableLayout_CmImageMapImpl_Fragment | CmTeasableLayout_CmInteractiveImpl_Fragment | CmTeasableLayout_CmLocTaxonomyImpl_Fragment | CmTeasableLayout_CmMediaImpl_Fragment | CmTeasableLayout_CmNavigationImpl_Fragment | CmTeasableLayout_CmPersonImpl_Fragment | CmTeasableLayout_CmPictureImpl_Fragment | CmTeasableLayout_CmPlaceholderImpl_Fragment | CmTeasableLayout_CmProductImpl_Fragment | CmTeasableLayout_CmQueryListImpl_Fragment | CmTeasableLayout_CmSelectionRulesImpl_Fragment | CmTeasableLayout_CmSpinnerImpl_Fragment | CmTeasableLayout_CmTaxonomyImpl_Fragment | CmTeasableLayout_CmTeasableImpl_Fragment | CmTeasableLayout_CmTeaserImpl_Fragment | CmTeasableLayout_CmVideoImpl_Fragment | CmTeasableLayout_CmVisualImpl_Fragment | CmTeasableLayout_FormEditorImpl_Fragment | CmTeasableLayout_SosAmountIncreaseFormImpl_Fragment | CmTeasableLayout_SosAuthorImpl_Fragment | CmTeasableLayout_SosChartImpl_Fragment | CmTeasableLayout_SosContactImpl_Fragment | CmTeasableLayout_SosDonationCardImpl_Fragment | CmTeasableLayout_SosDonationCertificateImpl_Fragment | CmTeasableLayout_SosDonationFormImpl_Fragment | CmTeasableLayout_SosDonationProductImpl_Fragment | CmTeasableLayout_SosDonationProgressImpl_Fragment | CmTeasableLayout_SosDonationToolImpl_Fragment | CmTeasableLayout_SosEventImpl_Fragment | CmTeasableLayout_SosFilterTeaserImpl_Fragment | CmTeasableLayout_SosInternalLinkImpl_Fragment | CmTeasableLayout_SosJobTeaserImpl_Fragment | CmTeasableLayout_SosLocationImpl_Fragment | CmTeasableLayout_SosNewsImpl_Fragment | CmTeasableLayout_SosNotificationImpl_Fragment | CmTeasableLayout_SosOfferImpl_Fragment | CmTeasableLayout_SosOrderFormImpl_Fragment | CmTeasableLayout_SosOrganisationImpl_Fragment | CmTeasableLayout_SosOverlayImpl_Fragment | CmTeasableLayout_SosPressreleaseImpl_Fragment | CmTeasableLayout_SosPublicationImpl_Fragment | CmTeasableLayout_SosRedirectPageImpl_Fragment | CmTeasableLayout_SosSpecialTopicCategoryImpl_Fragment | CmTeasableLayout_SosSpecialTopicImpl_Fragment | CmTeasableLayout_SosTeaserImpl_Fragment | CmTeasableLayout_SosTextfragmentImpl_Fragment | CmTeasableLayout_SosTooltipImpl_Fragment | CmTeasableLayout_SosWimmelbildImpl_Fragment | CmTeasableLayout_ViewTypeHeroCollection_Fragment;

export const CmTeasableLayoutFragmentDoc = gql`
    fragment CMTeasableLayout on CMTeasable {
  layoutSettings: settings(paths: ["contentWidth", "noBottomMargin"])
}
    `;